import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Container } from '@scentregroup/ui'
import { throttle } from '../../../helpers/'
import Menu from '../menu'
import Search from '../search'
import style from './index.scss'
import { NavigationMenuType } from './types'

const THROTTLE_SCROLL = 100

let headerStyle = classNames(style.stickHeader, style.header)

class Header extends Component {
  static toggleStickiness = isSticky => {
    if (isSticky) {
      headerStyle = classNames(style.stickHeader, style.header)
    } else {
      headerStyle = style.header
    }
  }
  constructor(props) {
    super(props)
    this.onScroll = throttle(this.onScroll.bind(this), THROTTLE_SCROLL)
    this.state = {
      sticky: false,
      searchQuery: props.searchQuery,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }

  setWrapper = ref => {
    this.wrapper = ref
  }

  onScroll() {
    if (this.wrapper) {
      this.setState({ sticky: this.wrapper.getBoundingClientRect().top <= 0 })
    }
  }

  render() {
    const { navigationMenu } = this.props
    return (
      <header
        ref={this.setWrapper}
        className={classNames(headerStyle, style.header, {
          [style.sticky]: this.state.sticky,
        })}
      >
        <Container className={style.container} type="large">
          <div className={style.menuWrap}>
            {navigationMenu && <Menu navigationMenu={navigationMenu} />}

            <Search
              placeholder={'Search products'}
              history={this.props.history}
              className={style.searchForm}
              searchQuery={this.state.searchQuery}
            />
          </div>
        </Container>
      </header>
    )
  }
}

Header.propTypes = {
  navigationMenu: NavigationMenuType,
  history: PropTypes.object,
  searchQuery: PropTypes.string,
}

export default Header
